import { createSlice } from '@reduxjs/toolkit'
import { THEME_CONFIG } from 'configs/AppConfig'

// Clé pour localStorage
const THEME_STORAGE_KEY = 'app_theme_preferences'

// Fonction pour charger les préférences depuis localStorage
const loadThemePreferences = () => {
	try {
	const savedPreferences = localStorage.getItem(THEME_STORAGE_KEY)
	if (savedPreferences) {
		const parsed = JSON.parse(savedPreferences)
		// Merge with THEME_CONFIG for defaults; keep saved locale from localStorage
		const merged = { ...THEME_CONFIG, ...parsed }
		return merged
	}
	} catch (error) {
		console.error('Error loading theme preferences from localStorage:', error)
	}
	return THEME_CONFIG
}

// Fonction pour sauvegarder les préférences dans localStorage
const saveThemePreferences = (state) => {
	try {
		const preferencesToSave = {
			navCollapsed: state.navCollapsed,
			sideNavTheme: state.sideNavTheme,
			locale: state.locale,
			navType: state.navType,
			topNavColor: state.topNavColor,
			headerNavColor: state.headerNavColor,
			currentTheme: state.currentTheme,
			direction: state.direction,
			blankLayout: state.blankLayout
		}
		localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(preferencesToSave))
	} catch (error) {
		console.error('Error saving theme preferences to localStorage:', error)
	}
}

export const initialState = loadThemePreferences()

export const themeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
        toggleCollapsedNav: (state, action) => {
			state.navCollapsed = action.payload
			saveThemePreferences(state)
		},
        onNavStyleChange: (state, action) => {
			state.sideNavTheme = action.payload
			saveThemePreferences(state)
		},
        onLocaleChange: (state, action) => {
			state.locale = action.payload
			saveThemePreferences(state)
		},
        onNavTypeChange: (state, action) => {
			state.navType = action.payload
			saveThemePreferences(state)
		},
        onTopNavColorChange: (state, action) => {
			state.topNavColor = action.payload
			saveThemePreferences(state)
		},
        onHeaderNavColorChange: (state, action) => {
			state.headerNavColor = action.payload
			saveThemePreferences(state)
		},
        onMobileNavToggle: (state, action) => {
			state.mobileNav = action.payload
			// Ne pas sauvegarder mobileNav car c'est temporaire
		},
        onSwitchTheme: (state, action) => {
			state.currentTheme = action.payload
			saveThemePreferences(state)
		},
        onDirectionChange: (state, action) => {
			state.direction = action.payload
			saveThemePreferences(state)
		},
		onBlankLayout: (state, action) => {
			state.blankLayout = action.payload
			saveThemePreferences(state)
		},
	},
})

export const { 
    toggleCollapsedNav,
    onNavStyleChange,
    onLocaleChange,
    onNavTypeChange,
    onTopNavColorChange,
    onHeaderNavColorChange,
    onMobileNavToggle,
    onSwitchTheme,
    onDirectionChange,
	onBlankLayout
} = themeSlice.actions

export default themeSlice.reducer